import React from 'react';

import { Tag } from 'antd';

import { WEBHOOK_AUTH_TYPE, WebhookAuthType } from '../types';

interface IWebhookAuthTagProps {
  authType: WebhookAuthType;
}

const AUTH_TYPE_LABEL: Record<string, string> = {
  [WEBHOOK_AUTH_TYPE.UNSPECIFIED]: 'Public',
  [WEBHOOK_AUTH_TYPE.PUBLIC]: 'Public',
  [WEBHOOK_AUTH_TYPE.BASIC]: 'Basic Auth',
  [WEBHOOK_AUTH_TYPE.API_KEY]: 'API Key',
  [WEBHOOK_AUTH_TYPE.HEADER]: 'Header Auth',
  [WEBHOOK_AUTH_TYPE.QUERY_PARAMETER]: 'Query Parameter',
};

export const WebhookAuthTag = ({ authType }: IWebhookAuthTagProps) => {
  const label = AUTH_TYPE_LABEL[authType] ?? authType;

  return <Tag color="processing">{label}</Tag>;
};
